import { useEffect } from 'react';

import { useAppDispatch } from '../state-manager/store';
import { fetchSystemVersion } from '../services/systemService';
import { setAppVersionAction } from '../state-manager/slices/appSlice';

export function useSystemInfoFulfill() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    fetchSystemVersion()
      .then((systemVersionDto) => {
        const appVersion = systemVersionDto.version;
        dispatch(setAppVersionAction({ appVersion }));
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }, []);
}
